import React from 'react'
import { Image, StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Text } from '@components'
import { Theme } from '@theme'
import { defaultImage } from '@assets'
import { useLanguage } from '@context'
import type { MutualContacts } from '../../../hooks/api/queries'

const AVATAR = 22

/** « 2 contacts en commun : Sofia Rossi, Lucas Moreau », with their faces. */
export const MutualContactsLine = ({ mutual }: { mutual?: MutualContacts }) => {
  const theme = useTheme()
  const styles = getStyle(theme)
  const { t } = useLanguage()
  if (!mutual?.count || mutual.people.length === 0) return null

  const names =
    mutual.people.map((person) => person.fullName).join(', ') +
    (mutual.count > mutual.people.length ? '…' : '')

  return (
    <View style={styles.row} testID="notification-mutual-contacts">
      <View style={styles.faces}>
        {mutual.people.slice(0, 2).map((person, index) => (
          <Image
            key={person.id}
            source={person.avatarUrl ? { uri: person.avatarUrl } : defaultImage}
            style={[styles.face, index > 0 && styles.faceOverlap]}
          />
        ))}
      </View>
      <Text type="bodySmall" color={theme.colors.greyBlue} style={styles.text} numberOfLines={2}>
        {t('notifications.details.mutual', { count: mutual.count, names })}
      </Text>
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.xs,
    },
    faces: {
      flexDirection: 'row',
    },
    face: {
      width: AVATAR,
      height: AVATAR,
      borderRadius: AVATAR / 2,
      borderWidth: 2,
      borderColor: theme.colors.white,
      backgroundColor: theme.colors.grey10,
    },
    faceOverlap: {
      marginLeft: -8,
    },
    text: {
      flex: 1,
    },
  })
